import React from "react"
import icon from "images/icons/icon-issue.svg"

export default function IssueIcon() {
  return (
    <span
      className="svg-icon svg-icon-issue"
      dangerouslySetInnerHTML={{ __html: icon }}
    />
  )
}
